import { render, staticRenderFns } from "./GotoLatestOrderByEmail.vue?vue&type=template&id=231396f3"
import script from "./GotoLatestOrderByEmail.vue?vue&type=script&lang=js"
export * from "./GotoLatestOrderByEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports